import * as Yup from 'yup';

export const outletsValidations = Yup.array().of(
    Yup.object().shape({
        tradingAddress: Yup.object().shape({
            eircode: Yup.string().required('Required'),
            addressLine1: Yup.string().required('Required'),
            townOrCity: Yup.string().required('Required'),
            country: Yup.string().required('Required'),
            county: Yup.string().required('Required'),
        }),
    })
);
